import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Layout from "./Layout";
import { routes } from "./Routes";
import SignIn from "./Shared/Login";

import BuilderPage from "./BuilderPage";
import { NotificationProvider } from "./Components/Websocket/NotificationContext";
import WebSocketListeners from "./Components/Websocket/WebsocketListsner";

function App() {
  return (
    <div className="overflow-x-hidden overflow-y-hidden">
      <BrowserRouter>
        <Routes>
          <Route path="/" index element={<SignIn />} />
          <Route path="*" element={<BuilderRoute />} />
          <Route element={<Layout />}>
            {routes.map((route) => {
              return (
                <Route
                  key={route.id}
                  path={route.path}
                  element={route.component}
                />
              );
            })}
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

const BuilderRoute = () => {
  const location = useLocation();
  return <BuilderPage url={location.pathname} />;
};

export default App;
